import { Console } from './console';
import { Account } from './account';
import { AppIssue } from './appissue';
import { DataSource } from './datasource';
import { Enterprise } from './enterprise';
import { Integration } from './integration';
import { Logs } from './logs';
import { Org } from './org';
import { Permission } from './permission';
import { ProcessMonitor } from './process-monitor';
import { Rulemanager } from './rulemanager';
import { SystemManage } from './system-manage';
import { UserPage, PageMenegement } from './userpage';
import { Application, AppMenegement, Application2 } from './application';
import { SystemConfig } from './system-config';

export default {
    path: '/backstage',
    name: 'back-stage',
    component: () =>
        import(/* webpackChunkName: "back-stage" */ '@/views/back-stage/back-stage.vue'),
    children: [
        Console,
        Account,
        AppIssue,
        DataSource,
        Enterprise,
        Integration,
        Logs,
        Org,
        Permission,
        ProcessMonitor,
        Rulemanager,
        SystemManage,
        UserPage,
        PageMenegement,
        Application,
        AppMenegement,
        Application2,
        SystemConfig,
        {
            path: '*',
            redirect: 'console',
        },
    ],
};
